/**
 * 客情管理
 */
export default {
  // deleteCustomerFollow: "/customerUser/deleteCustomerFollow", // 删除随访记录/{id}
  // downloadTemplate: "/customerUser/downloadTemplate", // 下载模板
  // getCustomerFollow: "/customerUser/getCustomerFollow", // 查询用户随访记录
  // getCustomerUser: "/customerUser/getCustomerUser", // 查询客情列表
  // getCustomerUserDetail: "/customerUser/getCustomerUserDetail", // 客情用户详情
  // importCustomerUser: "/customerUser/importCustomerUser", // 导入
  // insertCustomerFollow: "/customerUser/insertCustomerFollow", // 新增随访记录
  // updateCustomerFollow: "/customerUser/updateCustomerFollow", // 修改随访记录

  customerFollowinsert: "/customerFollow/insert", // 新增随访
  customerFollowselectCustomerFollow: "/customerFollow/selectCustomerFollow", // 查询用户详情随访记录列表
  customerFollowselectUserList: "/customerFollow/selectUserList", // 查询用户列表
  customerFollowupdate: "/customerFollow/update", // 修改随访

  customerFollowsaveUserDetail: "/customerFollow/saveUserDetail", //  新增/修改用户详情
  customerFollowselectUserDetail: "/customerFollow/selectUserDetail", //  查询用户详情

  user_msgselect_store_msg_info: "/user_msg/select_store_msg_info", // 查询群发通知详情-pc
  user_msgselect_store_msg_list: "/user_msg/select_store_msg_list", // 查询群发通知-pc
  user_msgsend_user_list_msg: "/user_msg/send_user_list_msg", // 群发通知-pc
}
